import queryString from 'query-string';

/**
 * 为url添加参数，如果addonParams存在和后端下发的参数重合，以后端为准
 * 如果addonParams里面存在blacklist里的参数，会被过滤
 * @param url 需要添加参数的url
 * @param addonParams 需要添加的参数
 * @param blacklist 需要过滤的参数, 如果有这些参数，一定是后端拼
 */
export const modifyUrlWithParams = (url: string, addonParams: { [key: string]: any } = {}, blacklist: string[] = []) => {
    try {
        const parseUrl = queryString.parseUrl(url);
        const originQuery = { ...(parseUrl.query || {}) };
        const addonParamsKeys = Object.keys(addonParams);

        addonParamsKeys.forEach((key) => {
            if (blacklist.includes(key) || originQuery.hasOwnProperty(key)) {
                return;
            }

            originQuery[key] = addonParams[key];
        });

        return queryString.stringifyUrl(
            {
                url: parseUrl.url,
                query: originQuery,
            },
            {
                skipNull: true,
                skipEmptyString: true,
            },
        );
    } catch (error) {
        return url;
    }
};
